import { useNavigate } from "@tanstack/react-router";
import { TikTokShopConnect } from "@/components/TikTokShopConnect";
import { Card, CardContent } from "@/components/ui/card";

export function TikTokConnect() {
  const navigate = useNavigate();

  const handleSuccess = () => {
    // Redirect to dashboard after success
    setTimeout(() => {
      navigate({ to: "/" });
    }, 2000);
  };

  return (
    <div className="min-h-screen bg-white">
      <div className="container max-w-2xl mx-auto py-8">
        <Card>
          <CardContent className="p-8">
            <TikTokShopConnect onSuccess={handleSuccess} />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
